// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Playfunia Chatbot — floating widget
   ============================================================ */

.Chatbot_widget__EUs2W {
  position: fixed;
  right: 1.5rem;
  /* Respect iOS safe-area at the bottom (notch + home indicator). */
  bottom: calc(1.5rem + env(safe-area-inset-bottom, 0px));
  z-index: 1100;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.75rem;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

/* ============================================================
   LAUNCHER (closed state) — FAB + cycling tooltip
   ============================================================ */

.Chatbot_launcher__-Rnhv {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.Chatbot_fab__Cu4m3 {
  position: relative;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 40%, #ec4899 75%, #6366f1 100%);
  background-size: 220% 220%;
  color: #fff;
  box-shadow:
    0 12px 28px rgba(99, 102, 241, 0.45),
    0 4px 8px rgba(236, 72, 153, 0.22),
    inset 0 1px 0 rgba(255, 255, 255, 0.25);
  display: grid;
  place-items: center;
  isolation: isolate;
  animation: Chatbot_fabShimmer__3P2gK 6s ease-in-out infinite;
  transition: transform 0.25s cubic-bezier(.34, 1.56, .64, 1),
              box-shadow 0.25s ease;
}

/* glossy top highlight */
.Chatbot_fab__Cu4m3::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.35), rgba(255, 255, 255, 0) 55%);
  pointer-events: none;
}

.Chatbot_fab__Cu4m3:hover {
  transform: translateY(-3px) scale(1.05);
  box-shadow:
    0 18px 38px rgba(99, 102, 241, 0.6),
    0 6px 12px rgba(236, 72, 153, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.35);
}

.Chatbot_fab__Cu4m3:active {
  transform: translateY(-1px) scale(0.98);
}

/* slowly rotating conic glow ring around the button */
.Chatbot_fabRing__IfhYS {
  position: absolute;
  inset: -3px;
  border-radius: 50%;
  padding: 2px;
  background: conic-gradient(from 0deg, #ec4899, #8b5cf6, #6366f1, #22d3ee, #ec4899);
  -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
  -webkit-mask-composite: xor;
  mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
  mask-composite: exclude;
  opacity: 0.85;
  z-index: -1;
  animation: Chatbot_fabSpin__ns2Nf 6s linear infinite;
}

/* "online" status dot */
.Chatbot_fabStatus__oP2ff {
  position: absolute;
  bottom: 3px;
  right: 3px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #22c55e;
  border: 2.5px solid #fff;
  box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.55);
  animation: Chatbot_fabStatusPulse__Z-QQh 2.4s ease-out infinite;
}

.Chatbot_fabIcon__BZEUZ {
  display: grid;
  place-items: center;
  animation: Chatbot_fabBob__31WlC 4s ease-in-out infinite;
}

/* pulsing halo behind the FAB */
.Chatbot_fabAura__PJ335 {
  position: absolute;
  inset: -4px;
  border-radius: 50%;
  background: radial-gradient(closest-side, rgba(139, 92, 246, 0.5), transparent 70%);
  z-index: -1;
  animation: Chatbot_fabPulse__RDFOS 2.6s ease-in-out infinite;
}

.Chatbot_fabSparkle__DxQTI {
  position: absolute;
  top: -4px;
  right: -2px;
  font-size: 14px;
  filter: drop-shadow(0 1px 2px rgba(0,0,0,0.18));
  animation: Chatbot_sparkle__aTexh 3.2s ease-in-out infinite;
}

@keyframes Chatbot_fabPulse__RDFOS {
  0%, 100% { transform: scale(1);    opacity: 0.55; }
  50%      { transform: scale(1.22); opacity: 0;    }
}

@keyframes Chatbot_fabBob__31WlC {
  0%, 100% { transform: translateY(0); }
  50%      { transform: translateY(-2px); }
}

@keyframes Chatbot_sparkle__aTexh {
  0%, 100% { transform: rotate(-8deg) scale(1);   opacity: 0.85; }
  50%      { transform: rotate(8deg)  scale(1.15); opacity: 1;    }
}

@keyframes Chatbot_fabShimmer__3P2gK {
  0%, 100% { background-position: 0% 50%; }
  50%      { background-position: 100% 50%; }
}

@keyframes Chatbot_fabSpin__ns2Nf {
  to { transform: rotate(360deg); }
}

@keyframes Chatbot_fabStatusPulse__Z-QQh {
  0%   { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.5); }
  70%  { box-shadow: 0 0 0 7px rgba(34, 197, 94, 0); }
  100% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0); }
}

/* Floating tooltip — cycles through capability phrases */
.Chatbot_tooltipBubble__F1rx2 {
  position: relative;
  max-width: 220px;
  padding: 0.55rem 0.95rem;
  background: rgba(255, 255, 255, 0.96);
  color: #1f2937;
  border: 1px solid rgba(99, 102, 241, 0.16);
  border-radius: 999px;
  box-shadow:
    0 14px 30px rgba(15, 23, 42, 0.12),
    0 2px 6px rgba(99, 102, 241, 0.08);
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: -0.01em;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  animation: Chatbot_bubbleFloat__RaIHl 5s ease-in-out infinite;
  backdrop-filter: blur(8px);
}

.Chatbot_tooltipBubble__F1rx2:hover {
  background: #fff;
  border-color: rgba(99, 102, 241, 0.3);
}

.Chatbot_tooltipPhrase__n6Mjn {
  display: inline-block;
  animation: Chatbot_phraseSwap__UCQM7 0.55s ease;
}

@keyframes Chatbot_phraseSwap__UCQM7 {
  from { opacity: 0; transform: translateY(4px); filter: blur(2px); }
  to   { opacity: 1; transform: translateY(0);   filter: blur(0);   }
}

@keyframes Chatbot_bubbleFloat__RaIHl {
  0%, 100% { transform: translateY(0); }
  50%      { transform: translateY(-3px); }
}

/* the little speech-tail pointing at the FAB */
.Chatbot_tooltipTail__VVwoN {
  position: absolute;
  right: -6px;
  top: 50%;
  width: 12px;
  height: 12px;
  background: rgba(255, 255, 255, 0.96);
  border-right: 1px solid rgba(99, 102, 241, 0.16);
  border-bottom: 1px solid rgba(99, 102, 241, 0.16);
  transform: translateY(-50%) rotate(-45deg);
}

/* ============================================================
   PANEL (opened state)
   ============================================================ */

.Chatbot_panel__jkOEl {
  width: min(420px, calc(100vw - 2rem));
  /* dvh = dynamic viewport height; behaves correctly under iOS Safari's
     collapsing URL bar where vh would otherwise overflow. */
  height: min(620px, calc(100dvh - 6rem));
  background: rgba(255, 255, 255, 0.98);
  border-radius: 22px;
  box-shadow:
    0 30px 60px rgba(15, 23, 42, 0.22),
    0 8px 20px rgba(99, 102, 241, 0.15),
    inset 0 1px 0 rgba(255, 255, 255, 0.6);
  border: 1px solid rgba(99, 102, 241, 0.18);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: Chatbot_panelIn__r7z4I 0.34s cubic-bezier(.34, 1.4, .64, 1);
  transform-origin: bottom right;
}

@keyframes Chatbot_panelIn__r7z4I {
  from { opacity: 0; transform: translateY(20px) scale(0.95); }
  to   { opacity: 1; transform: translateY(0)    scale(1);    }
}

/* Fullscreen variant — overlay centered */
.Chatbot_panelFullscreen__eOPK9 {
  position: fixed;
  inset: 0;
  width: min(960px, calc(100vw - 2rem));
  height: min(90dvh, calc(100dvh - 2rem));
  margin: auto;
  border-radius: 24px;
  animation: Chatbot_panelFsIn__xVMlr 0.32s cubic-bezier(.34, 1.4, .64, 1);
}

@keyframes Chatbot_panelFsIn__xVMlr {
  from { opacity: 0; transform: scale(0.96); }
  to   { opacity: 1; transform: scale(1);    }
}

.Chatbot_backdrop__nLa7E {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(4px);
  animation: Chatbot_backdropIn__qldT1 0.25s ease;
  z-index: -1;
}

@keyframes Chatbot_backdropIn__qldT1 {
  from { opacity: 0; }
  to   { opacity: 1; }
}

/* ---------------- header ---------------- */

.Chatbot_header__CKJzo {
  padding: 1rem 1.15rem;
  background:
    linear-gradient(120deg, rgba(99, 102, 241, 0.10), rgba(236, 72, 153, 0.10)),
    linear-gradient(180deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0));
  border-bottom: 1px solid rgba(99, 102, 241, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.Chatbot_headerLeft__RHR8I { display: flex; align-items: center; gap: 0.75rem; min-width: 0; }

.Chatbot_avatar__fStKG {
  position: relative;
  width: 42px; height: 42px;
  border-radius: 50%;
  background: linear-gradient(135deg, #6366f1, #8b5cf6 50%, #ec4899);
  color: #fff;
  display: grid; place-items: center;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.35);
}

.Chatbot_statusDot__lYGJp {
  position: absolute;
  right: -1px; bottom: -1px;
  width: 12px; height: 12px;
  background: #10b981;
  border: 2px solid #fff;
  border-radius: 50%;
  box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.6);
  animation: Chatbot_statusPulse__Oduyc 1.8s ease-out infinite;
}

@keyframes Chatbot_statusPulse__Oduyc {
  0%   { box-shadow: 0 0 0 0   rgba(16, 185, 129, 0.6); }
  70%  { box-shadow: 0 0 0 8px rgba(16, 185, 129, 0);   }
  100% { box-shadow: 0 0 0 0   rgba(16, 185, 129, 0);   }
}

.Chatbot_headerText__7I3wq { min-width: 0; }
.Chatbot_headerText__7I3wq h3 {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #1e293b;
  letter-spacing: -0.01em;
}
.Chatbot_statusText__8I1oe {
  font-size: 0.72rem;
  color: #64748b;
  font-weight: 500;
}

.Chatbot_headerActions__PgW9w { display: flex; align-items: center; gap: 0.35rem; }

.Chatbot_iconButton__WuNd4 {
  width: 32px; height: 32px;
  display: grid; place-items: center;
  background: rgba(99, 102, 241, 0.08);
  border: none;
  border-radius: 10px;
  color: #4f46e5;
  cursor: pointer;
  transition: background 0.15s ease, transform 0.15s ease;
}
.Chatbot_iconButton__WuNd4:hover {
  background: rgba(99, 102, 241, 0.16);
  transform: translateY(-1px);
}
.Chatbot_iconButton__WuNd4:active { transform: translateY(0); }

/* ---------------- messages ---------------- */

.Chatbot_messages__4P\\+eZ {
  flex: 1 1;
  overflow-y: auto;
  padding: 1rem 1.15rem 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  background:
    radial-gradient(900px 400px at 100% 0%, rgba(236, 72, 153, 0.05), transparent 60%),
    radial-gradient(700px 300px at 0% 100%, rgba(99, 102, 241, 0.05), transparent 60%);
  scroll-behavior: smooth;
}

.Chatbot_messages__4P\\+eZ::-webkit-scrollbar { width: 6px; }
.Chatbot_messages__4P\\+eZ::-webkit-scrollbar-thumb {
  background: rgba(99, 102, 241, 0.25);
  border-radius: 3px;
}

.Chatbot_message__bGvE\\+ {
  padding: 0.7rem 0.95rem;
  border-radius: 16px;
  font-size: 0.92rem;
  line-height: 1.55;
  max-width: 86%;
  word-wrap: break-word;
  animation: Chatbot_msgIn__xvPeZ 0.3s ease;
  color: #1e293b;
}

@keyframes Chatbot_msgIn__xvPeZ {
  from { opacity: 0; transform: translateY(6px); }
  to   { opacity: 1; transform: translateY(0); }
}

.Chatbot_messageUser__69IX7 {
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: #fff;
  align-self: flex-end;
  border-bottom-right-radius: 6px;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.22);
}

.Chatbot_messageUser__69IX7 strong { color: #fff; }
.Chatbot_messageUser__69IX7 .Chatbot_link__\\+raRM, .Chatbot_messageUser__69IX7 a { color: #fff; border-bottom-color: rgba(255,255,255,0.5); }

.Chatbot_messageBot__7X6O- {
  background: #fff;
  align-self: flex-start;
  border: 1px solid rgba(226, 232, 240, 0.9);
  border-bottom-left-radius: 6px;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.04);
}

/* ---------------- typing indicator ---------------- */

.Chatbot_typing__qgcrm {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 0.8rem 1rem;
}

.Chatbot_typingDot__pcB5b {
  width: 7px; height: 7px;
  border-radius: 50%;
  background: #8b5cf6;
  animation: Chatbot_typingBounce__2-Hu3 1.1s ease-in-out infinite;
}
.Chatbot_typingDot__pcB5b:nth-child(2) { animation-delay: 0.15s; }
.Chatbot_typingDot__pcB5b:nth-child(3) { animation-delay: 0.3s; }

@keyframes Chatbot_typingBounce__2-Hu3 {
  0%, 60%, 100% { transform: translateY(0);   opacity: 0.4; }
  30%           { transform: translateY(-4px); opacity: 1;   }
}

/* ---------------- quick-suggestion chips ---------------- */

.Chatbot_quickPrompts__P9DRm {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: 0.25rem 0 0.5rem;
}

.Chatbot_quickChip__La23q {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.5rem 0.85rem;
  background: #fff;
  border: 1px solid rgba(99, 102, 241, 0.2);
  border-radius: 999px;
  font-size: 0.83rem;
  font-weight: 500;
  color: #334155;
  cursor: pointer;
  opacity: 0;
  transform: translateY(6px);
  animation: Chatbot_chipIn__fplJO 0.35s ease forwards;
  transition: background 0.15s ease, border-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease;
}

.Chatbot_quickChip__La23q:hover {
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.07), rgba(236, 72, 153, 0.07));
  border-color: rgba(99, 102, 241, 0.4);
  transform: translateY(-2px);
  box-shadow: 0 6px 14px rgba(99, 102, 241, 0.12);
}

.Chatbot_quickChip__La23q:active { transform: translateY(0); }

.Chatbot_quickChip__La23q:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.Chatbot_chipEmoji__V9RoH { font-size: 1rem; line-height: 1; }

@keyframes Chatbot_chipIn__fplJO {
  from { opacity: 0; transform: translateY(6px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* ---------------- formatted content ---------------- */

.Chatbot_link__\\+raRM, .Chatbot_message__bGvE\\+ a {
  color: #6366f1;
  text-decoration: none;
  font-weight: 500;
  border-bottom: 1px solid rgba(99, 102, 241, 0.3);
  word-break: break-all;
  transition: all 0.15s ease;
}
.Chatbot_link__\\+raRM:hover, .Chatbot_message__bGvE\\+ a:hover {
  color: #4f46e5;
  border-bottom-color: #4f46e5;
}

.Chatbot_phoneLink__ldovz {
  color: #047857;
  text-decoration: none;
  font-weight: 600;
  background: rgba(16, 185, 129, 0.12);
  padding: 0.1rem 0.4rem;
  border-radius: 5px;
  white-space: nowrap;
  transition: background 0.15s ease;
}
.Chatbot_phoneLink__ldovz:hover { background: rgba(16, 185, 129, 0.22); }

.Chatbot_message__bGvE\\+ strong { font-weight: 700; color: #0f172a; }

/* ---------------- composer ---------------- */

.Chatbot_composer__evJlY {
  border-top: 1px solid rgba(148, 163, 184, 0.18);
  padding: 0.65rem 0.75rem;
  display: flex;
  gap: 0.5rem;
  align-items: flex-end;
  background: rgba(248, 250, 252, 0.6);
}

.Chatbot_composer__evJlY textarea {
  flex: 1 1;
  border: 1px solid rgba(148, 163, 184, 0.35);
  background: #fff;
  border-radius: 14px;
  padding: 0.6rem 0.9rem;
  resize: none;
  min-height: 40px;
  max-height: 140px;
  font-family: inherit;
  font-size: 0.92rem;
  line-height: 1.5;
  color: #1e293b;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.Chatbot_composer__evJlY textarea:focus {
  outline: none;
  border-color: rgba(99, 102, 241, 0.55);
  box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.12);
}

.Chatbot_composer__evJlY textarea::placeholder { color: rgba(100, 116, 139, 0.7); }

.Chatbot_composer__evJlY button {
  width: 40px; height: 40px;
  display: grid; place-items: center;
  background: linear-gradient(135deg, #6366f1, #8b5cf6 60%, #ec4899);
  color: #fff;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.32);
  transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
}

.Chatbot_composer__evJlY button:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(99, 102, 241, 0.42);
}
.Chatbot_composer__evJlY button:active:not(:disabled) { transform: translateY(0); }
.Chatbot_composer__evJlY button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  background: linear-gradient(135deg, #94a3b8, #cbd5e1);
  box-shadow: none;
}

.Chatbot_status__wKqIc {
  font-size: 0.82rem;
  color: #b91c1c;
  padding: 0 1rem 0.6rem;
  font-style: italic;
}

/* ---------------- powered-by footer ---------------- */

.Chatbot_poweredBy__tVj69 {
  text-align: center;
  padding: 0.4rem 1rem 0.55rem;
  font-size: 0.68rem;
  letter-spacing: 0.02em;
  color: #94a3b8;
  background: rgba(248, 250, 252, 0.6);
  border-top: 1px solid rgba(148, 163, 184, 0.12);
}

.Chatbot_poweredByBrand__R8RTh {
  font-weight: 700;
  background: linear-gradient(135deg, #6366f1, #8b5cf6 55%, #ec4899);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: #6366f1;
  text-decoration: underline;
  text-decoration-color: #8b5cf6;
  text-underline-offset: 2px;
  cursor: pointer;
}

/* ============================================================
   Responsive — mobile-first polish
   ============================================================ */

/* Tablets & small laptops: shrink the tooltip a touch, otherwise keep desktop layout. */
@media (max-width: 1024px) {
  .Chatbot_tooltipBubble__F1rx2 { max-width: 200px; font-size: 0.82rem; }
}

/* Phones: drop the cycling tooltip entirely (saves ~250px of horizontal space),
   shrink the FAB to a thumb-friendly 56px, and make the panel fill the viewport. */
@media (max-width: 640px) {
  .Chatbot_widget__EUs2W {
    right: 1rem;
    bottom: calc(1rem + env(safe-area-inset-bottom, 0px));
    gap: 0;
  }

  .Chatbot_tooltipBubble__F1rx2 { display: none; }
  .Chatbot_hideOnMobile__pb9iD { display: none; }

  .Chatbot_fab__Cu4m3 { width: 56px; height: 56px; }
  .Chatbot_fabSparkle__DxQTI { font-size: 13px; }

  .Chatbot_panel__jkOEl {
    width: calc(100vw - 0.5rem);
    height: calc(100dvh - 1rem);
    max-height: none;
    border-radius: 18px;
  }

  /* On phones, fullscreen and compact are visually identical — go truly
     edge-to-edge with no margin, no border-radius. */
  .Chatbot_panelFullscreen__eOPK9 {
    width: 100vw;
    height: 100dvh;
    border-radius: 0;
    inset: 0;
  }

  /* Suggestion chips: one line each so they're easy to tap on small screens. */
  .Chatbot_quickPrompts__P9DRm { gap: 0.4rem; }
  .Chatbot_quickChip__La23q { font-size: 0.82rem; padding: 0.48rem 0.8rem; }

  /* Header gets a bit tighter so the title doesn't wrap. */
  .Chatbot_header__CKJzo { padding: 0.85rem 0.95rem; }
  .Chatbot_avatar__fStKG { width: 38px; height: 38px; }
  .Chatbot_headerText__7I3wq h3 { font-size: 0.95rem; }
  .Chatbot_statusText__8I1oe  { font-size: 0.68rem; }
}

/* Extra-narrow phones (≤360px) — hide the "online" status sub-line so the
   header doesn't crowd. Avatar stays. */
@media (max-width: 360px) {
  .Chatbot_statusText__8I1oe { display: none; }
}

/* Landscape phones — viewport is short. Reduce panel margin so the keyboard
   doesn't crush the message area. */
@media (max-height: 540px) and (orientation: landscape) {
  .Chatbot_panel__jkOEl { height: calc(100dvh - 1rem); }
  .Chatbot_quickPrompts__P9DRm { gap: 0.35rem; }
  .Chatbot_quickChip__La23q { padding: 0.4rem 0.7rem; font-size: 0.78rem; }
}

/* Honor reduced motion for accessibility */
@media (prefers-reduced-motion: reduce) {
  .Chatbot_fabAura__PJ335, .Chatbot_fabSparkle__DxQTI, .Chatbot_fabIcon__BZEUZ, .Chatbot_fab__Cu4m3, .Chatbot_fabRing__IfhYS, .Chatbot_fabStatus__oP2ff, .Chatbot_tooltipBubble__F1rx2, .Chatbot_statusDot__lYGJp,
  .Chatbot_typingDot__pcB5b, .Chatbot_quickChip__La23q, .Chatbot_panel__jkOEl, .Chatbot_panelFullscreen__eOPK9, .Chatbot_backdrop__nLa7E, .Chatbot_message__bGvE\\+ {
    animation: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/chat/Chatbot.module.css"],"names":[],"mappings":"AAAA;;iEAEiE;;AAEjE;EACE,eAAe;EACf,aAAa;EACb,kEAAkE;EAClE,uDAAuD;EACvD,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,uGAAuG;AACzG;;AAEA;;iEAEiE;;AAEjE;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,uFAAuF;EACvF,0BAA0B;EAC1B,WAAW;EACX;;;2CAGyC;EACzC,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,4DAA6C;EAC7C;mCACiC;AACnC;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,0FAA0F;EAC1F,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;EACvC;;;2CAGyC;AAC3C;;AAEA;EACE,uCAAuC;AACzC;;AAEA,sDAAsD;AACtD;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kFAAkF;EAClF,8EAA8E;EAC9E,2BAA2B;EAC3B,sEAAsE;EACtE,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,oDAAqC;AACvC;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,2CAA2C;EAC3C,+DAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,wDAAyC;AAC3C;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,mFAAmF;EACnF,WAAW;EACX,4DAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,+CAA+C;EAC/C,2DAA4C;AAC9C;;AAEA;EACE,WAAW,mBAAmB,KAAK,aAAa,EAAE;EAClD,WAAW,sBAAsB,EAAE,UAAU,KAAK;AACpD;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,WAAW,2BAA2B,EAAE;AAC1C;;AAEA;EACE,WAAW,iCAAiC,IAAI,aAAa,EAAE;EAC/D,WAAW,oCAAoC,EAAE,UAAU,KAAK;AAClE;;AAEA;EACE,WAAW,2BAA2B,EAAE;EACxC,WAAW,6BAA6B,EAAE;AAC5C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,OAAO,0CAA0C,EAAE;EACnD,OAAO,0CAA0C,EAAE;EACnD,OAAO,wCAAwC,EAAE;AACnD;;AAEA,yDAAyD;AACzD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,qCAAqC;EACrC,cAAc;EACd,0CAA0C;EAC1C,oBAAoB;EACpB;;sCAEoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,6DAA8C;EAC9C,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,+CAAgC;AAClC;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE,iBAAiB,EAAE;EAClE,OAAO,UAAU,EAAE,wBAAwB,IAAI,eAAe,IAAI;AACpE;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,WAAW,2BAA2B,EAAE;AAC1C;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,gDAAgD;EAChD,iDAAiD;EACjD,0CAA0C;AAC5C;;AAEA;;iEAEiE;;AAEjE;EACE,qCAAqC;EACrC;4DAC0D;EAC1D,uCAAuC;EACvC,qCAAqC;EACrC,mBAAmB;EACnB;;;0CAGwC;EACxC,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,sEAAuD;EACvD,8BAA8B;AAChC;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,oCAAoC,KAAK;AAC9D;;AAEA,0CAA0C;AAC1C;EACE,eAAe;EACf,QAAQ;EACR,qCAAqC;EACrC,uCAAuC;EACvC,YAAY;EACZ,mBAAmB;EACnB,wEAAyD;AAC3D;;AAEA;EACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,OAAO,UAAU,EAAE,mBAAmB,KAAK;AAC7C;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,0BAA0B;EAC1B,+CAAgC;EAChC,WAAW;AACb;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA,6CAA6C;;AAE7C;EACE,qBAAqB;EACrB;;6EAE2E;EAC3E,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA,6BAAc,aAAa,EAAE,mBAAmB,EAAE,YAAY,EAAE,YAAY,EAAE;;AAE9E;EACE,kBAAkB;EAClB,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,kEAAkE;EAClE,WAAW;EACX,aAAa,EAAE,mBAAmB;EAClC,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,WAAW,EAAE,YAAY;EACzB,WAAW,EAAE,YAAY;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,2CAA2C;EAC3C,4DAA6C;AAC/C;;AAEA;EACE,OAAO,6CAA6C,EAAE;EACtD,OAAO,2CAA2C,IAAI;EACtD,OAAO,2CAA2C,IAAI;AACxD;;AAEA,6BAAc,YAAY,EAAE;AAC5B;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA,gCAAiB,aAAa,EAAE,mBAAmB,EAAE,YAAY,EAAE;;AAEnE;EACE,WAAW,EAAE,YAAY;EACzB,aAAa,EAAE,mBAAmB;EAClC,oCAAoC;EACpC,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,uDAAuD;AACzD;AACA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;AACA,oCAAqB,wBAAwB,EAAE;;AAE/C,+CAA+C;;AAE/C;EACE,SAAO;EACP,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX;;sFAEoF;EACpF,uBAAuB;AACzB;;AAEA,+CAA+B,UAAU,EAAE;AAC3C;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,yCAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,oBAAoB;EACpB,+BAA+B;EAC/B,+CAA+C;AACjD;;AAEA,qCAAsB,WAAW,EAAE;AACnC,mFAAqC,WAAW,EAAE,0CAA0C,EAAE;;AAE9F;EACE,gBAAgB;EAChB,sBAAsB;EACtB,0CAA0C;EAC1C,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA,uDAAuD;;AAEvD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,UAAU,EAAE,WAAW;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,gEAAiD;AACnD;AACA,yCAA0B,sBAAsB,EAAE;AAClD,yCAA0B,qBAAqB,EAAE;;AAEjD;EACE,gBAAgB,wBAAwB,IAAI,YAAY,EAAE;EAC1D,gBAAgB,2BAA2B,EAAE,UAAU,IAAI;AAC7D;;AAEA,6DAA6D;;AAE7D;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,yCAAyC;EACzC,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,UAAU;EACV,0BAA0B;EAC1B,oDAAqC;EACrC,uGAAuG;AACzG;;AAEA;EACE,uFAAuF;EACvF,qCAAqC;EACrC,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,mCAAoB,wBAAwB,EAAE;;AAE9C;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,4BAAa,eAAe,EAAE,cAAc,EAAE;;AAE9C;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA,wDAAwD;;AAExD;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,gDAAgD;EAChD,qBAAqB;EACrB,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,oCAAoC;EACpC,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;AACnC;AACA,kCAAmB,oCAAoC,EAAE;;AAEzD,kCAAkB,gBAAgB,EAAE,cAAc,EAAE;;AAEpD,+CAA+C;;AAE/C;EACE,+CAA+C;EAC/C,wBAAwB;EACxB,aAAa;EACb,WAAW;EACX,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,SAAO;EACP,2CAA2C;EAC3C,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA,iDAAkC,+BAA+B,EAAE;;AAEnE;EACE,WAAW,EAAE,YAAY;EACzB,aAAa,EAAE,mBAAmB;EAClC,kEAAkE;EAClE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,+CAA+C;EAC/C,2EAA2E;AAC7E;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;AACA,wDAAyC,wBAAwB,EAAE;AACnE;EACE,aAAa;EACb,mBAAmB;EACnB,qDAAqD;EACrD,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,wDAAwD;;AAExD;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,oCAAoC;EACpC,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,kEAAkE;EAClE,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,cAAc;EACd,0BAA0B;EAC1B,8BAA8B;EAC9B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;;iEAEiE;;AAEjE,wFAAwF;AACxF;EACE,gCAAiB,gBAAgB,EAAE,kBAAkB,EAAE;AACzD;;AAEA;mFACmF;AACnF;EACE;IACE,WAAW;IACX,qDAAqD;IACrD,MAAM;EACR;;EAEA,gCAAiB,aAAa,EAAE;EAChC,+BAAgB,aAAa,EAAE;;EAE/B,sBAAO,WAAW,EAAE,YAAY,EAAE;EAClC,6BAAc,eAAe,EAAE;;EAE/B;IACE,2BAA2B;IAC3B,2BAA2B;IAC3B,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;qDACmD;EACnD;IACE,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,QAAQ;EACV;;EAEA,6EAA6E;EAC7E,+BAAgB,WAAW,EAAE;EAC7B,4BAAa,kBAAkB,EAAE,uBAAuB,EAAE;;EAE1D,yDAAyD;EACzD,yBAAU,wBAAwB,EAAE;EACpC,yBAAU,WAAW,EAAE,YAAY,EAAE;EACrC,gCAAiB,kBAAkB,EAAE;EACrC,8BAAe,kBAAkB,EAAE;AACrC;;AAEA;wCACwC;AACxC;EACE,6BAAc,aAAa,EAAE;AAC/B;;AAEA;oCACoC;AACpC;EACE,wBAAS,2BAA2B,EAAE;EACtC,+BAAgB,YAAY,EAAE;EAC9B,4BAAa,sBAAsB,EAAE,kBAAkB,EAAE;AAC3D;;AAEA,2CAA2C;AAC3C;EACE;;IAEE,0BAA0B;EAC5B;AACF","sourcesContent":["/* ============================================================\n   Playfunia Chatbot — floating widget\n   ============================================================ */\n\n.widget {\n  position: fixed;\n  right: 1.5rem;\n  /* Respect iOS safe-area at the bottom (notch + home indicator). */\n  bottom: calc(1.5rem + env(safe-area-inset-bottom, 0px));\n  z-index: 1100;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 0.75rem;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\n}\n\n/* ============================================================\n   LAUNCHER (closed state) — FAB + cycling tooltip\n   ============================================================ */\n\n.launcher {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.fab {\n  position: relative;\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  border: none;\n  cursor: pointer;\n  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 40%, #ec4899 75%, #6366f1 100%);\n  background-size: 220% 220%;\n  color: #fff;\n  box-shadow:\n    0 12px 28px rgba(99, 102, 241, 0.45),\n    0 4px 8px rgba(236, 72, 153, 0.22),\n    inset 0 1px 0 rgba(255, 255, 255, 0.25);\n  display: grid;\n  place-items: center;\n  isolation: isolate;\n  animation: fabShimmer 6s ease-in-out infinite;\n  transition: transform 0.25s cubic-bezier(.34, 1.56, .64, 1),\n              box-shadow 0.25s ease;\n}\n\n/* glossy top highlight */\n.fab::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  border-radius: 50%;\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.35), rgba(255, 255, 255, 0) 55%);\n  pointer-events: none;\n}\n\n.fab:hover {\n  transform: translateY(-3px) scale(1.05);\n  box-shadow:\n    0 18px 38px rgba(99, 102, 241, 0.6),\n    0 6px 12px rgba(236, 72, 153, 0.3),\n    inset 0 1px 0 rgba(255, 255, 255, 0.35);\n}\n\n.fab:active {\n  transform: translateY(-1px) scale(0.98);\n}\n\n/* slowly rotating conic glow ring around the button */\n.fabRing {\n  position: absolute;\n  inset: -3px;\n  border-radius: 50%;\n  padding: 2px;\n  background: conic-gradient(from 0deg, #ec4899, #8b5cf6, #6366f1, #22d3ee, #ec4899);\n  -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);\n  -webkit-mask-composite: xor;\n  mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);\n  mask-composite: exclude;\n  opacity: 0.85;\n  z-index: -1;\n  animation: fabSpin 6s linear infinite;\n}\n\n/* \"online\" status dot */\n.fabStatus {\n  position: absolute;\n  bottom: 3px;\n  right: 3px;\n  width: 13px;\n  height: 13px;\n  border-radius: 50%;\n  background: #22c55e;\n  border: 2.5px solid #fff;\n  box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.55);\n  animation: fabStatusPulse 2.4s ease-out infinite;\n}\n\n.fabIcon {\n  display: grid;\n  place-items: center;\n  animation: fabBob 4s ease-in-out infinite;\n}\n\n/* pulsing halo behind the FAB */\n.fabAura {\n  position: absolute;\n  inset: -4px;\n  border-radius: 50%;\n  background: radial-gradient(closest-side, rgba(139, 92, 246, 0.5), transparent 70%);\n  z-index: -1;\n  animation: fabPulse 2.6s ease-in-out infinite;\n}\n\n.fabSparkle {\n  position: absolute;\n  top: -4px;\n  right: -2px;\n  font-size: 14px;\n  filter: drop-shadow(0 1px 2px rgba(0,0,0,0.18));\n  animation: sparkle 3.2s ease-in-out infinite;\n}\n\n@keyframes fabPulse {\n  0%, 100% { transform: scale(1);    opacity: 0.55; }\n  50%      { transform: scale(1.22); opacity: 0;    }\n}\n\n@keyframes fabBob {\n  0%, 100% { transform: translateY(0); }\n  50%      { transform: translateY(-2px); }\n}\n\n@keyframes sparkle {\n  0%, 100% { transform: rotate(-8deg) scale(1);   opacity: 0.85; }\n  50%      { transform: rotate(8deg)  scale(1.15); opacity: 1;    }\n}\n\n@keyframes fabShimmer {\n  0%, 100% { background-position: 0% 50%; }\n  50%      { background-position: 100% 50%; }\n}\n\n@keyframes fabSpin {\n  to { transform: rotate(360deg); }\n}\n\n@keyframes fabStatusPulse {\n  0%   { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.5); }\n  70%  { box-shadow: 0 0 0 7px rgba(34, 197, 94, 0); }\n  100% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0); }\n}\n\n/* Floating tooltip — cycles through capability phrases */\n.tooltipBubble {\n  position: relative;\n  max-width: 220px;\n  padding: 0.55rem 0.95rem;\n  background: rgba(255, 255, 255, 0.96);\n  color: #1f2937;\n  border: 1px solid rgba(99, 102, 241, 0.16);\n  border-radius: 999px;\n  box-shadow:\n    0 14px 30px rgba(15, 23, 42, 0.12),\n    0 2px 6px rgba(99, 102, 241, 0.08);\n  font-size: 0.85rem;\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  cursor: pointer;\n  overflow: hidden;\n  white-space: nowrap;\n  animation: bubbleFloat 5s ease-in-out infinite;\n  backdrop-filter: blur(8px);\n}\n\n.tooltipBubble:hover {\n  background: #fff;\n  border-color: rgba(99, 102, 241, 0.3);\n}\n\n.tooltipPhrase {\n  display: inline-block;\n  animation: phraseSwap 0.55s ease;\n}\n\n@keyframes phraseSwap {\n  from { opacity: 0; transform: translateY(4px); filter: blur(2px); }\n  to   { opacity: 1; transform: translateY(0);   filter: blur(0);   }\n}\n\n@keyframes bubbleFloat {\n  0%, 100% { transform: translateY(0); }\n  50%      { transform: translateY(-3px); }\n}\n\n/* the little speech-tail pointing at the FAB */\n.tooltipTail {\n  position: absolute;\n  right: -6px;\n  top: 50%;\n  width: 12px;\n  height: 12px;\n  background: rgba(255, 255, 255, 0.96);\n  border-right: 1px solid rgba(99, 102, 241, 0.16);\n  border-bottom: 1px solid rgba(99, 102, 241, 0.16);\n  transform: translateY(-50%) rotate(-45deg);\n}\n\n/* ============================================================\n   PANEL (opened state)\n   ============================================================ */\n\n.panel {\n  width: min(420px, calc(100vw - 2rem));\n  /* dvh = dynamic viewport height; behaves correctly under iOS Safari's\n     collapsing URL bar where vh would otherwise overflow. */\n  height: min(620px, calc(100dvh - 6rem));\n  background: rgba(255, 255, 255, 0.98);\n  border-radius: 22px;\n  box-shadow:\n    0 30px 60px rgba(15, 23, 42, 0.22),\n    0 8px 20px rgba(99, 102, 241, 0.15),\n    inset 0 1px 0 rgba(255, 255, 255, 0.6);\n  border: 1px solid rgba(99, 102, 241, 0.18);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  animation: panelIn 0.34s cubic-bezier(.34, 1.4, .64, 1);\n  transform-origin: bottom right;\n}\n\n@keyframes panelIn {\n  from { opacity: 0; transform: translateY(20px) scale(0.95); }\n  to   { opacity: 1; transform: translateY(0)    scale(1);    }\n}\n\n/* Fullscreen variant — overlay centered */\n.panelFullscreen {\n  position: fixed;\n  inset: 0;\n  width: min(960px, calc(100vw - 2rem));\n  height: min(90dvh, calc(100dvh - 2rem));\n  margin: auto;\n  border-radius: 24px;\n  animation: panelFsIn 0.32s cubic-bezier(.34, 1.4, .64, 1);\n}\n\n@keyframes panelFsIn {\n  from { opacity: 0; transform: scale(0.96); }\n  to   { opacity: 1; transform: scale(1);    }\n}\n\n.backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.45);\n  backdrop-filter: blur(4px);\n  animation: backdropIn 0.25s ease;\n  z-index: -1;\n}\n\n@keyframes backdropIn {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n/* ---------------- header ---------------- */\n\n.header {\n  padding: 1rem 1.15rem;\n  background:\n    linear-gradient(120deg, rgba(99, 102, 241, 0.10), rgba(236, 72, 153, 0.10)),\n    linear-gradient(180deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0));\n  border-bottom: 1px solid rgba(99, 102, 241, 0.08);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n}\n\n.headerLeft { display: flex; align-items: center; gap: 0.75rem; min-width: 0; }\n\n.avatar {\n  position: relative;\n  width: 42px; height: 42px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #6366f1, #8b5cf6 50%, #ec4899);\n  color: #fff;\n  display: grid; place-items: center;\n  flex-shrink: 0;\n  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.35);\n}\n\n.statusDot {\n  position: absolute;\n  right: -1px; bottom: -1px;\n  width: 12px; height: 12px;\n  background: #10b981;\n  border: 2px solid #fff;\n  border-radius: 50%;\n  box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.6);\n  animation: statusPulse 1.8s ease-out infinite;\n}\n\n@keyframes statusPulse {\n  0%   { box-shadow: 0 0 0 0   rgba(16, 185, 129, 0.6); }\n  70%  { box-shadow: 0 0 0 8px rgba(16, 185, 129, 0);   }\n  100% { box-shadow: 0 0 0 0   rgba(16, 185, 129, 0);   }\n}\n\n.headerText { min-width: 0; }\n.headerText h3 {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 700;\n  color: #1e293b;\n  letter-spacing: -0.01em;\n}\n.statusText {\n  font-size: 0.72rem;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.headerActions { display: flex; align-items: center; gap: 0.35rem; }\n\n.iconButton {\n  width: 32px; height: 32px;\n  display: grid; place-items: center;\n  background: rgba(99, 102, 241, 0.08);\n  border: none;\n  border-radius: 10px;\n  color: #4f46e5;\n  cursor: pointer;\n  transition: background 0.15s ease, transform 0.15s ease;\n}\n.iconButton:hover {\n  background: rgba(99, 102, 241, 0.16);\n  transform: translateY(-1px);\n}\n.iconButton:active { transform: translateY(0); }\n\n/* ---------------- messages ---------------- */\n\n.messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1rem 1.15rem 0.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.7rem;\n  background:\n    radial-gradient(900px 400px at 100% 0%, rgba(236, 72, 153, 0.05), transparent 60%),\n    radial-gradient(700px 300px at 0% 100%, rgba(99, 102, 241, 0.05), transparent 60%);\n  scroll-behavior: smooth;\n}\n\n.messages::-webkit-scrollbar { width: 6px; }\n.messages::-webkit-scrollbar-thumb {\n  background: rgba(99, 102, 241, 0.25);\n  border-radius: 3px;\n}\n\n.message {\n  padding: 0.7rem 0.95rem;\n  border-radius: 16px;\n  font-size: 0.92rem;\n  line-height: 1.55;\n  max-width: 86%;\n  word-wrap: break-word;\n  animation: msgIn 0.3s ease;\n  color: #1e293b;\n}\n\n@keyframes msgIn {\n  from { opacity: 0; transform: translateY(6px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.messageUser {\n  background: linear-gradient(135deg, #6366f1, #8b5cf6);\n  color: #fff;\n  align-self: flex-end;\n  border-bottom-right-radius: 6px;\n  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.22);\n}\n\n.messageUser strong { color: #fff; }\n.messageUser .link, .messageUser a { color: #fff; border-bottom-color: rgba(255,255,255,0.5); }\n\n.messageBot {\n  background: #fff;\n  align-self: flex-start;\n  border: 1px solid rgba(226, 232, 240, 0.9);\n  border-bottom-left-radius: 6px;\n  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.04);\n}\n\n/* ---------------- typing indicator ---------------- */\n\n.typing {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 0.8rem 1rem;\n}\n\n.typingDot {\n  width: 7px; height: 7px;\n  border-radius: 50%;\n  background: #8b5cf6;\n  animation: typingBounce 1.1s ease-in-out infinite;\n}\n.typingDot:nth-child(2) { animation-delay: 0.15s; }\n.typingDot:nth-child(3) { animation-delay: 0.3s; }\n\n@keyframes typingBounce {\n  0%, 60%, 100% { transform: translateY(0);   opacity: 0.4; }\n  30%           { transform: translateY(-4px); opacity: 1;   }\n}\n\n/* ---------------- quick-suggestion chips ---------------- */\n\n.quickPrompts {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  padding: 0.25rem 0 0.5rem;\n}\n\n.quickChip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  padding: 0.5rem 0.85rem;\n  background: #fff;\n  border: 1px solid rgba(99, 102, 241, 0.2);\n  border-radius: 999px;\n  font-size: 0.83rem;\n  font-weight: 500;\n  color: #334155;\n  cursor: pointer;\n  opacity: 0;\n  transform: translateY(6px);\n  animation: chipIn 0.35s ease forwards;\n  transition: background 0.15s ease, border-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease;\n}\n\n.quickChip:hover {\n  background: linear-gradient(135deg, rgba(99, 102, 241, 0.07), rgba(236, 72, 153, 0.07));\n  border-color: rgba(99, 102, 241, 0.4);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 14px rgba(99, 102, 241, 0.12);\n}\n\n.quickChip:active { transform: translateY(0); }\n\n.quickChip:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.chipEmoji { font-size: 1rem; line-height: 1; }\n\n@keyframes chipIn {\n  from { opacity: 0; transform: translateY(6px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n/* ---------------- formatted content ---------------- */\n\n.link, .message a {\n  color: #6366f1;\n  text-decoration: none;\n  font-weight: 500;\n  border-bottom: 1px solid rgba(99, 102, 241, 0.3);\n  word-break: break-all;\n  transition: all 0.15s ease;\n}\n.link:hover, .message a:hover {\n  color: #4f46e5;\n  border-bottom-color: #4f46e5;\n}\n\n.phoneLink {\n  color: #047857;\n  text-decoration: none;\n  font-weight: 600;\n  background: rgba(16, 185, 129, 0.12);\n  padding: 0.1rem 0.4rem;\n  border-radius: 5px;\n  white-space: nowrap;\n  transition: background 0.15s ease;\n}\n.phoneLink:hover { background: rgba(16, 185, 129, 0.22); }\n\n.message strong { font-weight: 700; color: #0f172a; }\n\n/* ---------------- composer ---------------- */\n\n.composer {\n  border-top: 1px solid rgba(148, 163, 184, 0.18);\n  padding: 0.65rem 0.75rem;\n  display: flex;\n  gap: 0.5rem;\n  align-items: flex-end;\n  background: rgba(248, 250, 252, 0.6);\n}\n\n.composer textarea {\n  flex: 1;\n  border: 1px solid rgba(148, 163, 184, 0.35);\n  background: #fff;\n  border-radius: 14px;\n  padding: 0.6rem 0.9rem;\n  resize: none;\n  min-height: 40px;\n  max-height: 140px;\n  font-family: inherit;\n  font-size: 0.92rem;\n  line-height: 1.5;\n  color: #1e293b;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.composer textarea:focus {\n  outline: none;\n  border-color: rgba(99, 102, 241, 0.55);\n  box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.12);\n}\n\n.composer textarea::placeholder { color: rgba(100, 116, 139, 0.7); }\n\n.composer button {\n  width: 40px; height: 40px;\n  display: grid; place-items: center;\n  background: linear-gradient(135deg, #6366f1, #8b5cf6 60%, #ec4899);\n  color: #fff;\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.32);\n  transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;\n}\n\n.composer button:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(99, 102, 241, 0.42);\n}\n.composer button:active:not(:disabled) { transform: translateY(0); }\n.composer button:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n  background: linear-gradient(135deg, #94a3b8, #cbd5e1);\n  box-shadow: none;\n}\n\n.status {\n  font-size: 0.82rem;\n  color: #b91c1c;\n  padding: 0 1rem 0.6rem;\n  font-style: italic;\n}\n\n/* ---------------- powered-by footer ---------------- */\n\n.poweredBy {\n  text-align: center;\n  padding: 0.4rem 1rem 0.55rem;\n  font-size: 0.68rem;\n  letter-spacing: 0.02em;\n  color: #94a3b8;\n  background: rgba(248, 250, 252, 0.6);\n  border-top: 1px solid rgba(148, 163, 184, 0.12);\n}\n\n.poweredByBrand {\n  font-weight: 700;\n  background: linear-gradient(135deg, #6366f1, #8b5cf6 55%, #ec4899);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  color: #6366f1;\n  text-decoration: underline;\n  text-decoration-color: #8b5cf6;\n  text-underline-offset: 2px;\n  cursor: pointer;\n}\n\n/* ============================================================\n   Responsive — mobile-first polish\n   ============================================================ */\n\n/* Tablets & small laptops: shrink the tooltip a touch, otherwise keep desktop layout. */\n@media (max-width: 1024px) {\n  .tooltipBubble { max-width: 200px; font-size: 0.82rem; }\n}\n\n/* Phones: drop the cycling tooltip entirely (saves ~250px of horizontal space),\n   shrink the FAB to a thumb-friendly 56px, and make the panel fill the viewport. */\n@media (max-width: 640px) {\n  .widget {\n    right: 1rem;\n    bottom: calc(1rem + env(safe-area-inset-bottom, 0px));\n    gap: 0;\n  }\n\n  .tooltipBubble { display: none; }\n  .hideOnMobile { display: none; }\n\n  .fab { width: 56px; height: 56px; }\n  .fabSparkle { font-size: 13px; }\n\n  .panel {\n    width: calc(100vw - 0.5rem);\n    height: calc(100dvh - 1rem);\n    max-height: none;\n    border-radius: 18px;\n  }\n\n  /* On phones, fullscreen and compact are visually identical — go truly\n     edge-to-edge with no margin, no border-radius. */\n  .panelFullscreen {\n    width: 100vw;\n    height: 100dvh;\n    border-radius: 0;\n    inset: 0;\n  }\n\n  /* Suggestion chips: one line each so they're easy to tap on small screens. */\n  .quickPrompts { gap: 0.4rem; }\n  .quickChip { font-size: 0.82rem; padding: 0.48rem 0.8rem; }\n\n  /* Header gets a bit tighter so the title doesn't wrap. */\n  .header { padding: 0.85rem 0.95rem; }\n  .avatar { width: 38px; height: 38px; }\n  .headerText h3 { font-size: 0.95rem; }\n  .statusText  { font-size: 0.68rem; }\n}\n\n/* Extra-narrow phones (≤360px) — hide the \"online\" status sub-line so the\n   header doesn't crowd. Avatar stays. */\n@media (max-width: 360px) {\n  .statusText { display: none; }\n}\n\n/* Landscape phones — viewport is short. Reduce panel margin so the keyboard\n   doesn't crush the message area. */\n@media (max-height: 540px) and (orientation: landscape) {\n  .panel { height: calc(100dvh - 1rem); }\n  .quickPrompts { gap: 0.35rem; }\n  .quickChip { padding: 0.4rem 0.7rem; font-size: 0.78rem; }\n}\n\n/* Honor reduced motion for accessibility */\n@media (prefers-reduced-motion: reduce) {\n  .fabAura, .fabSparkle, .fabIcon, .fab, .fabRing, .fabStatus, .tooltipBubble, .statusDot,\n  .typingDot, .quickChip, .panel, .panelFullscreen, .backdrop, .message {\n    animation: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"widget": `Chatbot_widget__EUs2W`,
	"launcher": `Chatbot_launcher__-Rnhv`,
	"fab": `Chatbot_fab__Cu4m3`,
	"fabShimmer": `Chatbot_fabShimmer__3P2gK`,
	"fabRing": `Chatbot_fabRing__IfhYS`,
	"fabSpin": `Chatbot_fabSpin__ns2Nf`,
	"fabStatus": `Chatbot_fabStatus__oP2ff`,
	"fabStatusPulse": `Chatbot_fabStatusPulse__Z-QQh`,
	"fabIcon": `Chatbot_fabIcon__BZEUZ`,
	"fabBob": `Chatbot_fabBob__31WlC`,
	"fabAura": `Chatbot_fabAura__PJ335`,
	"fabPulse": `Chatbot_fabPulse__RDFOS`,
	"fabSparkle": `Chatbot_fabSparkle__DxQTI`,
	"sparkle": `Chatbot_sparkle__aTexh`,
	"tooltipBubble": `Chatbot_tooltipBubble__F1rx2`,
	"bubbleFloat": `Chatbot_bubbleFloat__RaIHl`,
	"tooltipPhrase": `Chatbot_tooltipPhrase__n6Mjn`,
	"phraseSwap": `Chatbot_phraseSwap__UCQM7`,
	"tooltipTail": `Chatbot_tooltipTail__VVwoN`,
	"panel": `Chatbot_panel__jkOEl`,
	"panelIn": `Chatbot_panelIn__r7z4I`,
	"panelFullscreen": `Chatbot_panelFullscreen__eOPK9`,
	"panelFsIn": `Chatbot_panelFsIn__xVMlr`,
	"backdrop": `Chatbot_backdrop__nLa7E`,
	"backdropIn": `Chatbot_backdropIn__qldT1`,
	"header": `Chatbot_header__CKJzo`,
	"headerLeft": `Chatbot_headerLeft__RHR8I`,
	"avatar": `Chatbot_avatar__fStKG`,
	"statusDot": `Chatbot_statusDot__lYGJp`,
	"statusPulse": `Chatbot_statusPulse__Oduyc`,
	"headerText": `Chatbot_headerText__7I3wq`,
	"statusText": `Chatbot_statusText__8I1oe`,
	"headerActions": `Chatbot_headerActions__PgW9w`,
	"iconButton": `Chatbot_iconButton__WuNd4`,
	"messages": `Chatbot_messages__4P+eZ`,
	"message": `Chatbot_message__bGvE+`,
	"msgIn": `Chatbot_msgIn__xvPeZ`,
	"messageUser": `Chatbot_messageUser__69IX7`,
	"link": `Chatbot_link__+raRM`,
	"messageBot": `Chatbot_messageBot__7X6O-`,
	"typing": `Chatbot_typing__qgcrm`,
	"typingDot": `Chatbot_typingDot__pcB5b`,
	"typingBounce": `Chatbot_typingBounce__2-Hu3`,
	"quickPrompts": `Chatbot_quickPrompts__P9DRm`,
	"quickChip": `Chatbot_quickChip__La23q`,
	"chipIn": `Chatbot_chipIn__fplJO`,
	"chipEmoji": `Chatbot_chipEmoji__V9RoH`,
	"phoneLink": `Chatbot_phoneLink__ldovz`,
	"composer": `Chatbot_composer__evJlY`,
	"status": `Chatbot_status__wKqIc`,
	"poweredBy": `Chatbot_poweredBy__tVj69`,
	"poweredByBrand": `Chatbot_poweredByBrand__R8RTh`,
	"hideOnMobile": `Chatbot_hideOnMobile__pb9iD`
};
export default ___CSS_LOADER_EXPORT___;
